// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","GroupsGrid__row":"ru_a bih_a bih_r bih_sb bih_ry bih_rz","GroupsGrid__row__item":"ru_b bih_be bih_rz"};